<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Documento </span>
        </b-button>
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Documento -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Documento</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposDocumentos"
                            v-model="documentoConvenioDto.id_TipoDocumento"
                            text-field="vcDescricaoTipoDocumento"
                            value-field="idTipoDocumento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição do Arquivo</label>
                        <b-form-textarea
                            :rows="4"
                            v-model="documentoConvenioDto.vcDescricaoDocumento"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição do documento é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="documentoConvenioDto.arquivo"
                            :state="Boolean(documentoConvenioDto.arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click.stop="salvarDocumento()"
                    :disabled="this.$v.$invalid"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: {
            type: Object,
            default: () => ({})
        },
        desativarBotao: Boolean
    },

    validations: {
        id_TipoDocumento: { required },

        documentoConvenioDto: {
            vcDescricaoDocumento: { required },
            arquivo: { required }
        }
    },

    watch: {
        'documentoConvenioDto.id_TipoDocumento'() {
            this.id_TipoDocumento = null
            if (this.documentoConvenioDto.id_TipoDocumento > 0) {
                this.id_TipoDocumento =
                    this.documentoConvenioDto.id_TipoDocumento
            }
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'NOVO',
            erros: [],
            tiposDocumentos: [],

            //tipoDocumentoId: '',
            //descricaoArquivo: '',
            //descricao: '',
            //arquivo: null,

            id_TipoDocumento: null,

            documentoConvenioDto: {
                id_Documento: 0,
                id_Convenio: 0,
                id_TipoDocumento: '',
                vcDescricaoDocumento: '',
                vcNomeArquivo: '',
                idPrestacaoContasFinal: 0,
                arquivo: null
            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.obterTiposDocumentos()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterTiposDocumentos() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTiposDocumentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposDocumentos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarDocumento() {
            this.documentoConvenioDto.id_Convenio =
                this.$route.params.convenioId
            this.documentoConvenioDto.idPrestacaoContasFinal =
                this.parentData.idPrestacaoContasFinal
            this.documentoConvenioDto.vcNomeArquivo =
                this.documentoConvenioDto.arquivo.name

            this.$store.dispatch('addRequest')
            ConveniosServicos.inserirDocumentosPrestacaoContasFinal(
                this.documentoConvenioDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })

            this.fecharModal()
        }
    }
}
</script>
